import { useEffect, useState } from "react"

import config from "./config"
import NewsList from "./components/NewsList"

function App() {
  const [loadingCompleted, setLoadingCompleted] = useState(false)
  const [newsList, setNewsList] = useState([])

  function downloadIndex() {
    fetch(config["url-prefix"] + "index.json", {cache: "no-cache"}).then((response) => {
      return response.json()
    }).then(data => {
      setNewsList(data)
      setLoadingCompleted(true)
    })
  }

  useEffect(() => {
    if (!loadingCompleted) {
      downloadIndex()
    }
    return () => {}
  }, [loadingCompleted])

  return <NewsList news={newsList} />
}

export default App
